import { IntegrationsScreen } from '../features/integrations/IntegrationsScreen'
import { useShell } from '../app/outlet'

export function IntegrationsPage() {
  const { toast } = useShell()
  return <IntegrationsScreen onToast={toast} />
}
